// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"7916737d","290":"e503d617","415":"8668d658","512":"ff86e70a","649":"31a124ce"}[chunkId] + ".chunk.js";
};